import styled from 'styled-components';
import { media, Column, Row } from '@simplywallst/ui-core';

export interface MetricProps {
  type: 'Metric' | 'Data' | 'Updated';
}
export const MetricWrapper = styled(Row)<MetricProps>`
  height: 40px;
  ${media.lgUp`
    justify-content: ${({ type }) =>
      type === 'Data' || type === 'Updated' ? 'flex-end' : 'flex-start'};
    margin-top: ${({ type }) =>
      type === 'Data' || type === 'Updated' ? '18' : '0'}px;
    width: ${({ type }) =>
      type === 'Data' || type === 'Updated' ? 'max-content' : 'auto'};
    float: ${({ type }) =>
      type === 'Data' || type === 'Updated' ? 'right' : 'none'};

    margin-right: ${({ theme, type }) =>
      type === 'Data' ? '0' : theme.x3spacePx}px;
  `}
`;
export const TitleColumn = styled(Column)<MetricProps>`
  max-width: fit-content;
`;

export const Title = styled('p')<MetricProps>`
  margin: 0;
  opacity: 0.7;
  text-transform: uppercase;
  white-space: nowrap;
  ${({ theme }) => theme.typography.tiny}
  padding-right: ${({ theme }) => theme.x1spacePx}px;
  ${media.lgUp`
    text-align: left;
  `}
`;

export const MetricColumn = styled(Column)<MetricProps>`
  ${media.lgUp`
    flex: ${({ type }) =>
      type === 'Data' || type === 'Updated' ? '0 0 50%' : '0 0 100%'};
  `}
`;

export const Metric = styled('p')<MetricProps>`
  line-height: 1;
  margin: 0;
  white-space: nowrap;
  ${({ theme, type }) =>
    type === 'Data' || type === 'Updated'
      ? theme.typography.tiny
      : theme.typography.xSmallStrong}
  ${media.lgUp`
    text-align: ${({ type }) =>
      type === 'Data' || type === 'Updated' ? 'right' : 'left'};
  `}
`;
